export default {
  valueType: "BottomSubButton",
}

